// src/pages/NotFound.js
import React from 'react';

const NotFound = () => {
  return (
    <div className="mt-5">
      <h2>404 - Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
